import(/* webpackMode: "eager" */ "/codebuild/output/src652081793/src/medh-web/src/app/loading.tsx");
